<template>
  <el-dialog
    title='大屏维护'
    :visible.sync='visible'
    width='600px'
    center
    :close-on-click-modal='false'
    @close='dialogClose'>
    <div v-loading='formLoading'>
      <el-form :model='form' label-width='200px' :rules='rules' ref='ruleForm'
               size='medium' :validate-on-rule-change='false'>
        <el-form-item label='港口当日吞吐量是否滚动：' prop='throughputIsRoll'>
          <el-radio-group v-model='form.throughputIsRoll'>
            <el-radio label='是'>是</el-radio>
            <el-radio label='否'>否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label='品牌当日运量是否滚动：' prop='freightVolumeIsRoll'>
          <el-radio-group v-model='form.freightVolumeIsRoll'>
            <el-radio label='是'>是</el-radio>
            <el-radio label='否'>否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label='当前航次信息是否滚动：' prop='voyageIsRoll'>
          <el-radio-group v-model='form.voyageIsRoll'>
            <el-radio label='是'>是</el-radio>
            <el-radio label='否'>否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label='地图线路时间：' prop='startAndEnd'>
          <el-date-picker
            size='mini'
            v-model='form.startAndEnd'
            value-format='yyyy-MM-dd'
            type='daterange'
            align='right'
            unlink-panels
            range-separator='至'
            start-placeholder='开始日期'
            end-placeholder='结束日期'
            :picker-options='pickerOptions'>
          </el-date-picker>
        </el-form-item>
        <el-form-item label='上水装船效率品牌：' prop='brandIdsW'>
          <el-select v-model='form.brandIdsW' collapse-tags filterable multiple size='mini'
                     @change='changeWSelect' style='width: 100%; ' placeholder='请选择上水装船效率品牌'>
            <el-checkbox class='my-checkbox' v-model='checkedW' @change='selectWAll'>
              全选
            </el-checkbox>
            <el-option v-for='item in brandOptions' :key='item.id' :label='item.brand'
                       :value='item.id' />
          </el-select>
        </el-form-item>
        <el-form-item label='下水装船效率品牌：' prop='brandIdsE'>
          <el-select v-model='form.brandIdsE' collapse-tags filterable multiple size='mini'
                     @change='changeESelect' style='width: 100%; ' placeholder='请选择下水装船效率品牌'>
            <el-checkbox class='my-checkbox' v-model='checkedE' @change='selectEAll'>
              全选
            </el-checkbox>
            <el-option v-for='item in brandOptions' :key='item.id' :label='item.brand'
                       :value='item.id' />
          </el-select>
        </el-form-item>
        <div class='btnContainer'>
          <el-button size='medium' class='searchBtn' :loading='submitLoading' @click='submit'>
            确定
          </el-button>
          <el-button size='medium' class='resetBtn' @click='dialogClose'>关闭</el-button>
        </div>
      </el-form>
    </div>
  </el-dialog>
</template>

<script>
  import divBorder from '@/components/divBorder.vue';
  import { queryDataConfig, addOrUpdateDataConfig } from '@/service/DevOps';
  import { getModelList } from '@/service/vehiclelog';

  export default {
    name: 'index',
    components: { divBorder },
    data() {
      return {
        checkedW: false,
        checkedE: false,
        pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            },
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            },
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            },
          }],
        },
        visible: false,
        defaultForm: {},
        form: {
          startAndEnd: ['', ''],
          throughputIsRoll: 1,
          freightVolumeIsRoll: 1,
          voyageIsRoll: 1,
          brandIdsE: [],
          brandIdsW: [],
        },
        submitLoading: false,
        formLoading: false,
        userOptions: [],
        brandOptions: [],
        rules: {
          startAndEnd: [
            {
              required: true,
              message: '请选择地图线路时间',
              trigger: 'blur',
            },
          ],
          throughputIsRoll: [
            {
              required: true,
              message: '请选择港口当日吞吐量是否滚动',
              trigger: 'blur',
            },
          ],
          freightVolumeIsRoll: [
            {
              required: true,
              message: '请选择品牌当日运量是否滚动',
              trigger: 'blur',
            },
          ],
          voyageIsRoll: [
            {
              required: true,
              message: '请选择当前航次信息是否滚动',
              trigger: 'blur',
            },
          ],
          brandIdsE: [
            {
              required: true,
              message: '请选择上水装船效率品牌',
              trigger: 'blur',
            },
          ],
          brandIdsW: [
            {
              required: true,
              message: '请选择下水装船效率品牌',
              trigger: 'blur',
            },
          ],
        },
      };
    },
    mounted() {
      this.getDefaultData();
      this.defaultForm = JSON.parse(JSON.stringify(this.form));
    },
    methods: {
      selectWAll() {
        this.form.brandIdsW = [];
        if (this.checkedW) {
          this.brandOptions.map((item) => {
            this.form.brandIdsW.push(item.id);
          });
        } else {
          this.form.brandIdsW = [];
        }
      },
      selectEAll() {
        this.form.brandIdsE = [];
        if (this.checkedE) {
          this.brandOptions.map((item) => {
            this.form.brandIdsE.push(item.id);
          });
        } else {
          this.form.brandIdsE = [];
        }
      },
      changeWSelect(val) {
        this.checkedW = val.length === this.brandOptions.length;
      },
      changeESelect(val) {
        this.checkedE = val.length === this.brandOptions.length;
      },
      getDefaultData() {
        this.getModelList();
      },
      async getModelList() {
        const {
          status,
          message,
          data,
        } = await getModelList();
        if (status !== 0) return this.$message.warning(message);
        this.brandOptions = data;
      },
      submit() {
        this.$refs.ruleForm.validate(async (valid) => {
          if (valid) {
            this.submitLoading = true;
            const {
              status,
              message,
            } = await addOrUpdateDataConfig({
              ...this.form,
              startTime: this.form.startAndEnd[0],
              endTime: this.form.startAndEnd[1],
              brandIdsE: this.form.brandIdsE.join(','),
              brandIdsW: this.form.brandIdsW.join(','),
            });
            this.submitLoading = false;
            if (status !== 0) return this.$message.warning(message);
            this.$message.success(message);
            this.dialogClose();
          }
        });
      },
      openDialog() {
        this.visible = true;
        this.getDetail();
      },
      async getDetail() {
        this.formLoading = true;
        const {
          status,
          message,
          data,
        } = await queryDataConfig();
        this.formLoading = false;
        if (status !== 0) return this.$message.warning(message);
        this.form = data || JSON.parse(JSON.stringify(this.defaultForm));
        if (data.startTime && data.endTime) this.$set(this.form, 'startAndEnd', [data.startTime, data.endTime]);
      },
      dialogClose() {
        this.visible = false;
        this.form = JSON.parse(JSON.stringify(this.defaultForm));
      },
    },
  };
</script>

<style lang='scss' scoped>
  .el-form-item {
    margin-top: 18px;
  }

  .btnContainer {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 30px 0 10px 0;

    button {
      margin: 0 15px;
    }
  }
</style>
